// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2WOLx","title":"Header_title__1ALqQ","left":"Header_left__1jPYR","clinicName":"Header_clinicName__3pF7A"};